export function ZinniaProvider({ children, }) {
    return children;
}
//# sourceMappingURL=ZinniaProvider.js.map
// @zapier/design-system-context@1.6.0 (32c6128cc)
